export default __webpack_public_path__ + "static/media/WBTCeth.d8219479.svg";